export const accessLogKeys = {
  all: ['accessLogs'] as const,
  list: (documentSuperId: number | string, filter: unknown) => ['accessLogs', documentSuperId, filter],
  filters: () => ['accessLogsFilters'],
  create: () => ['createAccessLog'],
};
